export enum cookieNames {
  Advertising = 'BM_Advertising',
  Analytics = 'BM_Analytics',
  UserExperience = 'BM_User_Experience',
}
